import { Worksheet } from "exceljs";

export const autoWidth = (worksheet: Worksheet, minimalWidth: number = 10, maximumWidth: number | null = null) => {
    worksheet.columns.forEach((column) => {
        let maxColumnLength = 0;
        if (!column.eachCell) return;

        column.eachCell({ includeEmpty: true }, (cell) => {
            if (maximumWidth && maximumWidth < maxColumnLength) maxColumnLength = maximumWidth;
            else
                maxColumnLength = Math.max(
                    maxColumnLength,
                    minimalWidth,
                    cell.value ? cell.value.toString().length : 0
                );
        });
        column.width = maxColumnLength + 2;
    });
};
